import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { SelectItem } from 'lib/common';

@Component({
  selector: 'app-dropdown-multilevel',
  templateUrl: './dropdown-multilevel.component.html',
  styleUrls: ['./dropdown-multilevel.component.scss',
    '../styles/list-menu.css',
    '../styles/input.css',]
})
export class DropdownMultilevelComponent implements OnInit {
  showMainUL: boolean;
  showSubULNotNeeded: boolean;
  topSearchDisplay = false;//IMP
  @Input() cancelMessage: string;
  @Input() clearMessage: string;
  @Input() searchMessage: string;

  //IMP - Added to remove button if only list box needed
  @Input() cancelDisplay: boolean = true;
  @Input() clearDisplay: boolean = true;
  @Input() listItemWidth: number = 100;
  @Input() options: SelectItem[];

  @Input('selected')
  get model(): any[] { return this._model; }
  set model(val: any[]) {
    this._model = val;
    this.selectedOptions = (val && val.length) ? val.slice(0) : [];
  }
  private _model: any[] = [];

  @Input()
  get isOpen(): boolean { return this._isOpen; }
  set isOpen(val: boolean) {
    this._isOpen = val;
    if (val === true) {
      this.setFocus();
      this.searchFilterText = null;
    }
  }
  private _isOpen: boolean;

  @Output() selectionChange: EventEmitter<any> = new EventEmitter();
  @Output() selectionCancel: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('filterInput', { static: false }) filterInput: any;
  searchFilterText: string = null;
  private selectedOptions: any[] = [];

  navMenuNodes: any[] = [
    {
      name: 'First menu',
      expanded: true,
      children: [
        { id: '/crud-table-demo', name: 'Menu 1 link 1' },
        { id: '/data-table-demo', name: 'Menu 1 link 2' },
        {
          name: 'Submenu ',
          expanded: true,
          children: [
            { id: '/nav-menu-demo', name: 'Submenu link 1' },
            { id: '/data-table-demo', name: 'Submenu link 2' },
            { id: '/tree-table-demo', name: 'Submenu link 3' },
          ]
        },
      ]
    },
    {
      name: 'Second menu',
      children: [
        { id: '/crud-table-demo', name: 'Menu 2 link 1' },
        { id: '/data-table-demo', name: 'Menu 2 link 2' },
        { id: '/tree-table-demo', name: 'Menu 2 link 3' },
      ]
    },
    {
      name: 'With icons',
      icon: 'dt-icon-reload',
      children: [
        { id: '/crud-table-demo', name: 'Menu 2 link 1', icon: 'dt-icon-shrink' },
        { id: '/data-table-demo', name: 'Menu 2 link 2', icon: 'dt-icon-reload' },
        { id: '/tree-table-demo', name: 'Menu 2 link 3', icon: 'dt-icon-shrink' },
      ]
    }
  ];


  constructor() { }

  ngOnInit() {
    //console.log('load') 
  }


  showOrHideMainUL() {
   this.showMainUL = !this.showMainUL;
  }

  currShowDDL = -1;
  actualCurrShowDDLForSubs = -1;
  showOrHideSubUL(value: any, showSubUL: any) {
    //console.log('main click')
    this.currShowDDL = showSubUL == 1 ? 2 : (showSubUL == 2 ? 1 : -1);//-1 - no need, 1 - yet to expand, 2 - expand and show
    this.actualCurrShowDDLForSubs = this.currShowDDL;
    if (value == 0 || value == 3 || value == 12)
      this.currShowDDL = 2;
    //console.log(value)
    //console.log(this.model[0])
    const optFound = this.options.find(x => x.id == value);
    if (optFound)
      optFound.showSubUL = this.currShowDDL;
    this.options.forEach(x => { if (x.id != value) { x.showSubUL = x.showSubUL > 0 ? 1 : -1 } });
  }
  showOrHideUL(value: any) {
    //console.log('sub click')
    this.currShowDDL = 1;
  }

  isSelected(value: any): boolean {
   ////This add multiple items checked to array - IMP
    //this.selectionChangeEmit();

    //return this.selectedOptions.indexOf(value) > -1;
    if ((this.selectedOptions[0] >= 0 && this.selectedOptions[0] <= 1) && value == 0) {
      return true;
    }
    else if ((this.selectedOptions[0] >= 3 && this.selectedOptions[0] <= 11) && value == 3) {
      return true;
    }
    else if ((this.selectedOptions[0] >= 12 && this.selectedOptions[0] <= 14) && value == 12) {
      return true;
    }

    return this.selectedOptions[0] == value;
  }
  isSubSelected(value: any): boolean {
    //console.log(this.currShowDDL)
    //console.log(value)
    //console.log(this.selectedOptions[0])
    ////This add multiple items checked to array - IMP
    //this.selectionChangeEmit();

    //return this.selectedOptions.indexOf(value) > -1;
    return this.selectedOptions[0] == value && this.actualCurrShowDDLForSubs != 2;
  }

  setSelectedOptions(value: any) {
   //const index = this.selectedOptions.indexOf(value);
    //if (index > -1) {
    //  this.selectedOptions.splice(index, 1);
    //} else {
      ////if (this.multiple) {
      ////  this.selectedOptions.push(value);
      ////} else {
        this.selectedOptions = [];
    this.selectedOptions.push(value);
      ////}
    //}
  }

  resetSubValue = -1;
  setSelected(event: MouseEvent, value: any) {

   event.stopPropagation();
    this.resetSubValue = -1;
    if ((this.selectedOptions[0] == 1 && value == 0)
      || (this.selectedOptions[0] >= 3 && this.selectedOptions[0] <= 11 && value == 3)
      || (this.selectedOptions[0] >= 12 && this.selectedOptions[0] <= 14 && value == 12)) {
      this.resetSubValue = this.selectedOptions[0];
    }
    else
      this.setSelectedOptions(value);
    //if (!this.multiple) {
      this.selectionChangeEmit();
    //}
  }
  setSubSelected(event: MouseEvent, value: any) {
   event.stopPropagation();
    this.setSelectedOptions(value);
   //if (!this.multiple) {
    this.selectionChangeEmit();
    //}
  }

  setFocus() {
    //console.log(this._model)
    this.selectedOptions = this._model;
    let value = this._model[0];
    let subFound = false;
    if (this._model[0] >= 0 && this._model[0] <= 1) {
      value = 0;
      subFound = true;
    }
    else if (this._model[0] >= 3 && this._model[0] <= 11) {
      value = 3;
      subFound = true;
    }
    else if (this._model[0] >= 12 && this._model[0] <= 14) {
      value = 12;
      subFound = true;
    }
    const optFound = this.options.find(x => x.id == value);
    if (optFound) {
      if (subFound)
        optFound.showSubUL = 2;
      else
        optFound.showSubUL = -1;
    }
    this.options.forEach(x => { if (x.id != value) { x.showSubUL = x.showSubUL > 0 ? 1 : -1 } });

    if (this.filterInput) {
      setTimeout(() => {
        this.filterInput.nativeElement.focus();
      }, 1);
    }
  }

  onClickCancel(event: MouseEvent) {
    event.stopPropagation();
    this.selectedOptions = this.model.slice(0);
    this.selectionCancel.emit(true);
  }

  onClickClear(event: MouseEvent) {
    event.stopPropagation();
    if (this.selectedOptions.length > 0) {
      this.selectedOptions = [];
    }
    this.selectionChangeEmit();
  }

  selectionChangeEmit() {
    if (this.model.length === this.selectedOptions.length
      && this.model.every((value, index) => value === this.selectedOptions[index] && (value !== 0 && value !== 3 && value !== 12))
      && this.resetSubValue == -1) {
      this.selectionCancel.emit(true);
    } else {
      this.model = this.selectedOptions.slice(0);
      this.model.push(this.currShowDDL);//needed to open or close ddl li list in parent item
      this.selectionChange.emit(this.model);
    }
  }

}
